import React from 'react';
import { useViewMode } from 'app/shared/hooks/useViewMode';
import ListIcon from './ListIcon';
import { FeedIcon } from 'app/shared/halo/components/ui/icons';
import { mobileToggleButton, iconStyle } from './viewModeToggle.styles';

const MobileViewModeToggle = () => {
  const [viewMode, setViewMode] = useViewMode();
  const isGrid = viewMode === 'grid';

  return (
    <button
      type="button"
      className={mobileToggleButton}
      onClick={() => setViewMode(isGrid ? 'feed' : 'grid')}
      aria-label={isGrid ? 'Switch to feed view' : 'Switch to list view'}
    >
      {isGrid ? <FeedIcon className={iconStyle} /> : <ListIcon className={iconStyle} />}
    </button>
  );
};

export default MobileViewModeToggle;
